<h3 class="hvac-landing-page-heading hvac-h3">{{results.title}}</h3>
<ul class="hvac-marketing-links">
    <li class="hvac-marketing-links-item" *ngFor="let resource of results.items">
        <hvac-public-link [resource]="resource"></hvac-public-link>
    </li>
</ul>
